module.exports = __webpack_public_path__ + "static/img/topbg-off.d6d9ac25.png";